var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.688.75H1.5a.875.875 0 00-.875.875v8.75a.875.875 0 00.875.875h2.188a.875.875 0 00.874-.875v-8.75A.875.875 0 003.688.75zm0 9.625H1.5v-8.75h2.188v8.75zM8.5.75H6.312a.875.875 0 00-.875.875v8.75a.875.875 0 00.875.875H8.5a.875.875 0 00.875-.875v-8.75A.875.875 0 008.5.75zm0 9.625H6.312v-8.75H8.5v8.75z"
  })));
}
export default SvgColumns;